import React, { useEffect } from 'react'
import Additional from './Additional'
import Comment from './Comment'

const Phpfullstack = () => {
  useEffect(() => {
    window.scrollTo(900, 900);
  }, []);

  return (
    <div>
<div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div className="container py-5">
    <div className="row g-5">
      <div className="col-lg-8">
        {/* Blog Detail Start */}
        <div className="mb-5">
          <h1 className="mb-4">Why PHP Full Stack Developer</h1>
          <p>Discover our comprehensive PHP full stack development course curriculum, designed to provide hands-on experiences in building versatile applications. Our experienced instructors bring industry expertise to guide you through the journey, adapting to your skill level. After completing the course successfully, you'll be equipped for assured placements and valuable certification from TechPro Academy.</p>
          <p><b>Session 1: Introduction to Web Development</b></p>
          <p>Understanding Client-Server Architecture, Basics of HTML and CSS</p>
          <b>Session 2: Introduction to PHP</b>
          <p>PHP Basics, Syntax, Variables, Data Types, Operators</p>
          <b>Session 3: Control Structures</b>
          <p>Conditional Statements, Loops, Switch Statements</p>
          <b>Session 4: PHP Functions</b>
          <p>Creating and Using Functions, Function Parameters and Return Values</p>
          <b>Session 5: Arrays and Strings</b>
          <p>Working with Arrays, Manipulating Strings</p>
          <b>Session 6: Object-Oriented PHP</b>
          <p>Introduction to OOP, Classes and Objects, Inheritance, Polymorphism</p>
          <b>Session 7: MySQL Database</b>
          <p>Database Fundamentals, SQL Queries, CRUD Operations</p>
          <b>Session 8: PHP and MySQL Integration</b>
          <p>Connecting PHP with MySQL, Building Dynamic Web Applications</p>
          <b>Session 9: Web Security</b>
          <p>Common Web Vulnerabilities, Sanitization, Validation, Authentication</p>
          <b>Session 10: Frontend Technologies</b>
          <p>Introduction to JavaScript, DOM Manipulation, AJAX</p>
          <b>Session 11: PHP Frameworks</b>
          <p>Exploring Laravel Framework for PHP Development</p>
          <b>Session 12: RESTful APIs</b>
          <p>Building and Consuming RESTful APIs for Web Applications</p>
          <b>Session 13: Version Control with Git</b>
          <p>Using Git for Collaboration and Source Code Management</p>
          <b>Session 14: Deployment and Hosting</b>
          <p>Deploying PHP Applications, Web Hosting Options</p>
          <b>Session 15: Project Development</b>
          <p>Guided Project to Apply Learned Concepts in Real-world Scenarios</p>
        </div>
        {/* Blog Detail End */}
        {/* Comment List Start */}
        <Comment/>
        {/* Comment Form End */}
      </div>
      {/* Sidebar Start */}
      <div className="col-lg-4">
        {/* Search Form Start */}
        <Additional/>
        {/* Plain Text End */}
      </div>
      {/* Sidebar End */}
    </div>
 
  </div>
</div>


    </div>
  )
}

export default Phpfullstack